
import React from 'react'
const json = {
    username: '',
    password: '',
    userToken : ''
}

export default json;
